"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beginnerTutorialDeleteById = beginnerTutorialDeleteById;
exports.beginnerTutorialPageList = beginnerTutorialPageList;
exports.beginnerTutorialSaveOrUpdate = beginnerTutorialSaveOrUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
// 保存、修改新手教程
function beginnerTutorialSaveOrUpdate(data) {
  return (0, _request.default)({
    url: '/portal/system/beginnerTutorial/saveOrUpdate',
    method: 'post',
    data: data
  });
}
function beginnerTutorialPageList(data) {
  return (0, _request.default)({
    url: '/portal/system/beginnerTutorial/pageList',
    method: 'post',
    data: data
  });
}
function beginnerTutorialDeleteById(data) {
  return (0, _request.default)({
    url: '/portal/system/beginnerTutorial/deleteById',
    method: 'post',
    data: data
  });
}